import { useSortable } from '@dnd-kit/sortable'
import React, { useEffect, useState } from 'react'
import { Badge } from 'src/components/ui/badge'
import DataTable from './DataTable/DataTable'
const DropLineIndicator = () => <div className="w-1 h-1 bg-gray-500 mx-1" />
const SortablePill = ({ item }: { item: any & { calculatedWidth: number } }) => {
  const [isMounted, setIsMounted] = useState(false)
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id: item.id })

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <Badge
      ref={setNodeRef}
      style={{ width: item.calculatedWidth }}
      className={`
          px-2 py-1
          rounded-md
          text-white 
          cursor-grab 
          flex 
          items-center 
          justify-center
          transition-colors
          whitespace-nowrap
          ${isMounted && isDragging ? 'opacity-50' : ''}
        `}
      {...(isMounted ? attributes : {})}
      {...(isMounted ? listeners : {})}
    >
      {item.title}
    </Badge>
  )
}
export default function TableOfContentDetails({ doc, loadDocument, variant, setDoc }) {
  return (
    <div>
      <h1>Table of Content</h1>
      <DataTable loadDocument={loadDocument} data={doc.sections} variant={variant} isLoading={false} setDoc={setDoc} />
    </div>
  )
}
